import {
  GetProviderOriganizationListActionTypes,
  GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_FAIL,
  GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_LOADING,
  GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_SUCCESS,
  GetProviderOrgAdministratorListState,
  GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_API_MSG,
  GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_API_RES,
} from "./ActionTypes";
import { GetProviderOrganizationAdministratorListRes } from "./Model";

const initialStateUpdatePosts: GetProviderOrgAdministratorListState = {
  loading: false,
  getProviderOrgAdministratorRes: {} as GetProviderOrganizationAdministratorListRes,
  errorMsg: "",
  status: 0,
};
export const getProviderOrganizationAdministratorListReducer = (
  state = initialStateUpdatePosts,
  action: GetProviderOriganizationListActionTypes
): GetProviderOrgAdministratorListState => {
  switch (action.type) {
    case GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_SUCCESS:
      return {
        ...state,
        getProviderOrgAdministratorRes: action.payload,
      };
    case GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_FAIL:
      return {
        ...state,
        getProviderOrgAdministratorRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_API_MSG:
      return {
        ...state,
        getProviderOrgAdministratorRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    case GET_PROVIDER_ORGANIZATION_ADMINISTRATOR_LIST_API_RES:
      return {
        ...state,
        getProviderOrgAdministratorRes: action.payload,
        errorMsg: action.errorMsg,
        status: action.status,
      };
    default:
      return state;
  }
};
